export const FETCH_QUOTES = 'FETCH_QUOTES';
export const NEW_QUOTE = 'NEW_QUOTE';
